import React, { useEffect } from "react";

import useBoostController from "shared/hooks/useBoostController";
import Modal from "shared/components/Modal";
import Strf from "shared/components/Strf";
import ClientStats from "shared/util/ClientStats";
import _str from "shared/util/_str";
import withModalController from "shared/hocs/withModalController";

import "./RushHourModal.scss";

const RushHourModal = withModalController(({ userid }) => {
	const { startBoost } = useBoostController({ userid });

	useEffect(() => {
		ClientStats.update("rush hour - modal opened");
	}, []);

	const onClickClose = () => {
		ClientStats.update("rush hour - modal closed");
		RushHourModal.close();
	};

	const onClickPromote = () => {
		ClientStats.update("rush hour - modal promote me clicked");
		RushHourModal.close();

		// Open Boost UI.
		startBoost();
	};

	return (
		<Modal
			className="rush-hour-modal"
			noClose
			show
		>
			<div className="heading">
				<h3>{_str("It’s rush hour!")}</h3>
			</div>
			<div className="desc">
				<p className="desc-text">
					<Strf vars={{ br: <br /> }}>
						We’re experiencing peak site traffic.$br Boost now and be seen by more matches.
					</Strf>
				</p>
			</div>
			<div className="content">
				<button className="rush-hour-promote flatbutton blue" onClick={onClickPromote}>
					<span className="icon i-boost" />
					{_str("Promote me")}
				</button>
				<button className="rush-hour-dismiss" onClick={onClickClose}>
					{_str("No thanks")}
				</button>
			</div>
		</Modal>
	);
}, "modal_rush_hour");

export default RushHourModal;



// WEBPACK FOOTER //
// ./src/shared/components/RushHourModal.jsx